"use client";

import { Button } from "@/components/shadcn/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/shadcn/ui/card";
import { CheckCircle } from "lucide-react";
import { EmailPreview } from "@/components/templates/contact/email-preview";

interface ThankYouMessageProps {
	onReset: () => void;
	emailPreviewData?: any;
	formType?: "contact" | "support";
}

export function ThankYouMessage({
	onReset,
	emailPreviewData,
	formType,
}: ThankYouMessageProps) {
	return (
		<div>
			<Card className="text-center animate-scaleIn">
				<CardHeader
					style={{ backgroundColor: "#00AEEF" }}
					className="text-white"
				>
					<CardTitle className="flex justify-center items-center gap-2">
						<CheckCircle className="h-6 w-6 animate-pulse-subtle" />
						Thank You for Contacting Us
					</CardTitle>
				</CardHeader>
				<CardContent className="pt-6 pb-8">
					<div className="space-y-4 max-w-2xl mx-auto">
						<p
							className="text-lg animate-fadeIn"
							style={{ animationDelay: "0.1s" }}
						>
							We&apos;ve received your inquiry and appreciate you reaching out to us.
						</p>
						<p className="animate-fadeIn" style={{ animationDelay: "0.2s" }}>
							Our team is reviewing your message and will get back to you as
							soon as possible, typically within 1-2 business days. We&apos;re
							committed to providing you with the information and support you
							need.
						</p>
						<p className="animate-fadeIn" style={{ animationDelay: "0.3s" }}>
							If your matter is urgent, please call our customer service line at
							<span className="font-medium"> 1-888-HYGIENA</span>.
						</p>
						<div
							className="pt-4 animate-fadeIn"
							style={{ animationDelay: "0.4s" }}
						>
							<Button
								onClick={onReset}
								style={{ backgroundColor: "#00AEEF" }}
								className="button-press transition-all duration-300 hover:brightness-110"
							>
								Submit Another Inquiry
							</Button>
						</div>
					</div>
				</CardContent>
			</Card>

			{/* Email Preview Section */}
			{emailPreviewData && formType && (
				<EmailPreview emailData={emailPreviewData} formType={formType} />
			)}
		</div>
	);
}
